module.exports = __webpack_public_path__ + "img/search-icon.8464aec1.svg";